import React, { PureComponent } from 'react';
import Auxiliary from "util/Auxiliary";

class CreateQuiz extends PureComponent {

    render() {
        return (
            <Auxiliary>
                <span>Create Quiz</span>
            </Auxiliary>
        );
    }

}

export default CreateQuiz;